"use client";

import { useParams } from "next/navigation";
import { env } from "../setup/env";
import { type LanguageKey, languageKeys } from "../types/language";

/**
 * Retrieves the current locale from the Next.js dynamic route parameters. This param get’s validated.
 * If the param is not valid, returns "en" as defaultValue
 */
export const useLocale = () => {
  const params = useParams();
  if (params.locale && languageKeys.includes(params.locale as LanguageKey)) {
    return params.locale as LanguageKey;
  }
  return env.NEXT_PUBLIC_I18N as LanguageKey;
};